import { useEffect } from "react";

import useOrg from "../hooks/useOrg";

export default function HubSpotTracking() {
  const { loggedInUser } = useOrg();

  useEffect(() => {
    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(["identify", { email: loggedInUser.email }]);
  }, [loggedInUser.email]);

  return null;
}
